/**
 * AFF aircraft hover/click interaction logic (#820 step 6), shared by the
 * marker and the 3D model layer. Pure functions only; the DOM wiring stays in
 * the provider.
 */

import { isHeartbeatRow, formatHeartbeatHover, formatHeartbeatPopup } from './affHeartbeatPopup';
import { hoverLabel } from './affMarkerLabel';
import { markerPropsToAircraft } from './affMarkerToAircraft';
import type { AffAircraftEntity } from '../../../components/explorers/affExplorer/affServiceAdapter';

/**
 * Hover text exactly as markerFunction computes it today (#781): for a
 * heartbeat row, the shared heartbeat hover text; otherwise the full
 * Selkirk-composed label, unmodified.
 */
export function markerRowHoverText(props: Record<string, any>): string {
  if (isHeartbeatRow(props)) return formatHeartbeatHover(props);
  return hoverLabel(props);
}

export type AffMarkerClickAction =
  | { kind: 'heartbeatPopup'; html: string }
  | { kind: 'showAircraft'; aircraft: AffAircraftEntity; options: { iconHeight: number } };

/**
 * Click behaviour shared identically by both marker builders today: a
 * heartbeat row asks for its dedicated popup content, an aircraft row asks
 * for the shared detail-modal dispatch. The two builders differ only in how
 * they style the resulting Popup (className/offset), which is DOM wiring and
 * stays in the provider.
 */
export function clickActionFor(
  props: Record<string, any>,
  coords: [number, number],
  iconHeight: number,
): AffMarkerClickAction {
  if (isHeartbeatRow(props)) {
    return { kind: 'heartbeatPopup', html: formatHeartbeatPopup(props) };
  }
  return {
    kind: 'showAircraft',
    aircraft: markerPropsToAircraft(props, coords),
    options: { iconHeight },
  };
}
